import { render, staticRenderFns } from "./VxeEditBtn.vue?vue&type=template&id=20f1160f&scoped=true"
import script from "./VxeEditBtn.vue?vue&type=script&lang=js"
export * from "./VxeEditBtn.vue?vue&type=script&lang=js"
import style0 from "./VxeEditBtn.vue?vue&type=style&index=0&id=20f1160f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1160f",
  null
  
)

export default component.exports